import { useFiltersModalContext } from 'components/FiltersModalProvider/FiltersModalProvider';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { SelectedPills } from 'components/SelectedPills/SelectedPills';
import { BasicButton } from 'components/buttons/BasicButton/BasicButton';
import { useAppContext } from 'contexts/appContext';
import { useCallback, useEffect, useRef } from 'react';
import { APPLIED_FILTERS_WIDTH } from '../CruiseSearchWidget/constants';
import styles from './FiltersApplied.css';

export function FiltersApplied() {
	const { dictionary } = useAppContext();
	const { clearNumberOfGuestsApplied } = useFiltersModalContext();
	const { appliedHistoricalSelection, removeHistoricalSelectionPill, clearApplied } = useFiltersContext();

	const { actionModalResetAll } = dictionary;

	const pillsContainer = useRef<HTMLDivElement>(null);
	const buttonFilterArray = Array.from(document.querySelectorAll('[class*=FilterDropdown_root]'));

	const onResetClick = useCallback(() => {
		clearApplied();
		clearNumberOfGuestsApplied();
	}, [clearApplied, clearNumberOfGuestsApplied]);

	useEffect(() => {
		const totalFilterButtonWidth = buttonFilterArray.reduce(function (acc, obj) {
			return acc + obj.clientWidth + APPLIED_FILTERS_WIDTH.baseMargin;
		}, 0);
		if (pillsContainer.current) {
			pillsContainer.current.style.maxWidth = totalFilterButtonWidth
				? `${totalFilterButtonWidth.toString()}px`
				: APPLIED_FILTERS_WIDTH.defaultMaxWidth;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pillsContainer.current, buttonFilterArray]);

	return (
		<div ref={pillsContainer} className={styles.root} data-testid="selected-filters-container">
			<SelectedPills
				selection={appliedHistoricalSelection}
				optionTestId="pill-{{label}}-selected-filters-button"
				onOptionCrossClick={(option) => removeHistoricalSelectionPill(option, true)}
				rootClass={styles.filters}
			/>
			<div className={styles.buttons}>
				<BasicButton
					testId="reset-all-filters-button"
					customClass={styles.textButton}
					label={actionModalResetAll}
					onClick={onResetClick}
					variant="text"
				/>
			</div>
		</div>
	);
}
